import React from 'react';

const EditableAdditionalFields = ({
  additionalFields,
  onLabelChange,
  onValueChange,
  onAddField,
  onRemoveField
}) => (
  <div className="pt-2">
    <div className="flex items-center justify-between mb-2">
      <h2 className="text-sm font-semibold text-gray-200 uppercase tracking-wide">
        Additional details
      </h2>
      <button
        type="button"
        onClick={onAddField}
        className="text-sm text-violet-300 hover:text-violet-200 transition-colors"
      >
        + Add field
      </button>
    </div>
    <div className="space-y-3">
      {additionalFields.length === 0 && (
        <p className="text-xs text-gray-400">
          No extra attributes detected. You can add your own.
        </p>
      )}
      {additionalFields.map((item, index) => (
        <div
          key={`additional-field-${index}`}
          className="space-y-2"
        >
          <div className="relative">
            <label className="block text-xs text-gray-400 mb-1">Attribute</label>
            <input
              value={item.attribute}
              onChange={(event) => onLabelChange(index, event.target.value)}
              placeholder="Label"
              className="w-full bg-gray-800/50 backdrop-blur text-white placeholder-gray-500 rounded-2xl px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-violet-500 border border-gray-700"
            />
            {onRemoveField && (
              <button
                type="button"
                onClick={() => onRemoveField(index)}
                className="absolute top-0 right-0 p-1 text-red-300 hover:text-red-200 hover:bg-red-500/10 rounded transition-colors"
                title="remove this attribute"
              >
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>
          <div>
            <label className="block text-xs text-gray-400 mb-1">Value</label>
            <textarea
              value={item.value ?? ''}
              onChange={(event) => onValueChange(index, event.target.value)}
              placeholder="Value"
              rows="3"
              className="w-full bg-gray-800/50 backdrop-blur text-white placeholder-gray-500 rounded-2xl px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-violet-500 border border-gray-700 resize-vertical"
            />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export { EditableAdditionalFields };

